import { IconButton, Select, MenuItem, Typography, Box } from "@mui/material";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

const PaginationBox = ({ page, count, rowsPerPage, onPageChange, onRowsPerPageChange }: any) => {
    const totalPages = Math.ceil(count / rowsPerPage);

    return (
        <Box display="flex" alignItems="center" justifyContent="space-between" p={2}>
            <Box display="flex" alignItems="center">
                <Select value={rowsPerPage} onChange={(e) => onRowsPerPageChange(e.target.value)} size="small">
                    {[5, 10, 25].map((size) => (
                        <MenuItem key={size} value={size}>{size}</MenuItem>
                    ))}
                </Select>
                <Typography variant="body2" sx={{ mr: 1, marginLeft: 1 }}>Items per page</Typography>
            </Box>

            <Box display="flex" alignItems="center">
                <IconButton onClick={() => onPageChange(0)} disabled={page === 0}>
                    <FirstPageIcon />
                </IconButton>
                <IconButton onClick={() => onPageChange(-1)} disabled={page === 0}>
                    <NavigateBeforeIcon />
                </IconButton>
                <IconButton onClick={() => onPageChange(1)} disabled={page >= totalPages - 1}>
                    <NavigateNextIcon />
                </IconButton>
            </Box>
        </Box>
    );
};

export default PaginationBox;